<template>
    <div class="searchInput" @click="onClickInput">
        <form action="/">
            <van-search :left-icon="'https://image.carisok.com/images/search_icon.png'" @search="onSearch" @cancel="onCancel" show-action v-model="text" :placeholder="placeholder" clearable>
                <template #action>
                    <div @click="onSearch" v-if="hasSearch">搜索</div>
                    <slot v-else></slot>
                </template>
            </van-search>
        </form>
    </div>
</template>

<script>
export default {
    name: 'searchInput',
    props: {
        placeholder: {
            type: String,
            default: '请输入内容'
        },
        hasSearch: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            text: '',
        }
    },
    methods: {
        /**
         * 点击文本框
         */
        onClickInput () {
            this.$emit('onClickInput')
        },
        /**
         * 清空文本框
         */
        onClearInput () {
            this.text = ''
        },
        /**
         * 搜索
         */
        onSearch () {
            this.$emit('onSearch', this.text)
        },
        /**
         * 取消
         */
        onCancel () {
            console.log('onCancel')
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/stylus/variables.styl";
@import "~@/assets/stylus/mixin.styl";
>>> .van-search__content
        border-radius 30px
        background #efefef
>>> .van-image__img
        width 40px
        height 40px
        position relative
        top 4px
        opacity 0.6
>>> .van-search__action
        color #3b3b3b
        font-size 28px
</style>
